module.exports = __webpack_public_path__ + "static/media/sample_bulk_coil_force_close.431f20ee.csv";